// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2loWv","colMin":"styles_colMin__6NzQR","colCheckbox":"styles_colCheckbox__sv4je"};